import React, { useEffect, useState } from "react";
import formatDateTime from "./formatDateTime";

export interface Props {
  date?: Date;
}

const CurrentDateTime: React.FC<Props> = ({ date }) => {
  if (!date) {
    date = new Date();
  }

  const [now, setNow] = useState(date);
  const { date: currentDate, time: currentTime } = formatDateTime(now);

  useEffect(() => {
    const intervalId = setInterval(() => setNow(new Date()), 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="dqm-tcui-current_date_time">
      <div className="dqm-tcui-current_date_time__time">{currentTime}</div>
      <div className="dqm-tcui-current_date_time__date">{currentDate}</div>
    </div>
  );
};

export default CurrentDateTime;
